export const stepDotClass = (s) => {
  if (s.current) return "bg-emerald-500 border-emerald-500";
  if (s.done) return "bg-emerald-100 border-emerald-300";
  return "bg-white border-navy-200";
};

const STAGE_PILL = {
  emerald: "bg-emerald-100 text-emerald-700",
  amber: "bg-amber-100 text-amber-700",
};
export const stagePillClass = (colour) => STAGE_PILL[colour] || "bg-navy-100 text-navy-700";
